import { abortIfNotPermitted } from '../../utils';
import Auth from '@js/plugins/auth';

export default [
    {
        path: '/',
        component: () =>
            import(/* webpackChunkName: "supplier" */ '@js/franchise_component/franchise-inventory/supplier/supplier-index.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_view_inventory_supplier',
                next,
            );
        },
    },
    {
        path: '/create',
        component: () =>
            import(/* webpackChunkName: "supplier" */ '@js/franchise_component/franchise-inventory/supplier/supplier-create.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_manage_inventory_supplier',
                () => {
                    if (
                        !Auth.hasPermissionTo(
                            'franchise_manage_inventory_supplier',
                        )
                    ) {
                        abortIfNotPermitted(
                            'franchise_create_inventory_supplier',
                            next,
                        );
                    } else {
                        next();
                    }
                },
            );
        },
    },
    {
        path: '/:id',
        component: () =>
            import(/* webpackChunkName: "supplier" */ '@js/franchise_component/franchise-inventory/supplier/supplier-edit.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_view_inventory_supplier',
                next,
            );
        },
    },
];
